export default __webpack_public_path__ + "static/media/Service1.7baa6467.png";